import React from 'react'
import cx from 'classnames'
import { useIntl } from 'intl'
import { formatPrice } from 'helpers'

import { Text, type TextStyle } from 'components/dataDisplay'

import messages from './messages'
import s from './ProductPrice.scss'


type ProductPriceProps = {
  className?: string
  textStyle?: TextStyle
  oldPriceClassName?: string
  newPriceClassName?: string
  withNbsp?: boolean
} & AtLeastOne<{
  data: ProductFragment.EcommercePrices
  formattedData: {
    discountPrice: string
    standardPrice: string
  }
}>

// TODO should we use currencyCode from data? - added on 14.01.2022 by sonatskiy
const ProductPrice: React.FunctionComponent<ProductPriceProps> = (props) => {
  const { className, data, formattedData, textStyle = 'h8', oldPriceClassName, newPriceClassName, withNbsp = true } = props

  const intl = useIntl()

  const discountPrice = data?.discountPrice?.amount
  const standardPrice = data?.standardPrice?.amount

  let finalPrice
  let oldPrice
  let oldPriceLabel
  let newPriceLabel

  if (formattedData) {
    const { discountPrice, standardPrice } = formattedData
    finalPrice = discountPrice || standardPrice

    if (finalPrice !== standardPrice) {
      oldPrice = standardPrice
      oldPriceLabel = intl.formatMessage(messages.old)
      newPriceLabel = intl.formatMessage(messages.new)
    }
  }
  else {
    if (typeof discountPrice === 'number') {
      // it's formatted as USD, not cents
      finalPrice = formatPrice(discountPrice, { isCents: false })


      if (standardPrice > discountPrice) {
        oldPrice = formatPrice(standardPrice, { isCents: false })
        oldPriceLabel = intl.formatMessage(messages.old)
        newPriceLabel = intl.formatMessage(messages.new)
      }
    }
    else if (typeof standardPrice === 'number') {
      finalPrice = formatPrice(standardPrice, { isCents: false })
    }
  }

  if (!finalPrice) {
    return null
  }

  if (oldPrice) {
    return (
      <Text className={className} style={textStyle}>
        <s className={cx(s.oldPrice, oldPriceClassName)} aria-label={oldPriceLabel} data-testid="oldPrice">{oldPrice}</s>
        {withNbsp && ' '}
        <strong className={cx('font-bold', newPriceClassName)} aria-label={newPriceLabel} data-testid="price">{finalPrice}</strong>
      </Text>
    )
  }

  return (
    <Text className={cx(className, newPriceClassName)} style={textStyle} data-testid="price">
      {finalPrice}
    </Text>
  )
}


export default React.memo(ProductPrice)
